export const LOCALES = ["en", "zh", "it"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

export const LOCALE_META: Record<Locale, { label: string; name: string; htmlLang: string; dateLocale: string; ogLocale: string }> = {
  en: { label: "EN", name: "English", htmlLang: "en", dateLocale: "en-GB", ogLocale: "en_GB" },
  zh: { label: "中文", name: "中文", htmlLang: "zh-Hans", dateLocale: "zh-CN", ogLocale: "zh_CN" },
  it: { label: "IT", name: "Italiano", htmlLang: "it", dateLocale: "it-IT", ogLocale: "it_IT" },
};

export const SITE_URL = "https://bionexus.news";

const isLocale = (v: string | undefined): v is Locale => !!v && (LOCALES as readonly string[]).includes(v);

/** Reads the locale from the first path segment ("/zh/materials" → "zh"). */
export const localeFromPath = (pathname: string): Locale => {
  const seg = pathname.split("/")[1];
  return isLocale(seg) && seg !== DEFAULT_LOCALE ? seg : DEFAULT_LOCALE;
};

/** Removes a locale prefix: "/it/materials" → "/materials". */
export const stripLocale = (pathname: string) => {
  const seg = pathname.split("/")[1];
  if (isLocale(seg) && seg !== DEFAULT_LOCALE) {
    const rest = pathname.slice(seg.length + 1);
    return rest.startsWith("/") ? rest : `/${rest}`;
  }
  return pathname || "/";
};

/** Prefixes an app path for a locale; English lives at the root. */
export const localizePath = (path: string, locale: Locale) => {
  if (locale === DEFAULT_LOCALE) return path;
  if (path === "/") return `/${locale}`;
  return `/${locale}${path}`;
};
